var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "yoyo-container mx-auto min-h-screen" },
    [
      _c("navBar"),
      _c("div", { staticClass: "md:mx-4 bg-[#FFC736] md:hidden" }, [
        _vm._m(0),
        _c(
          "div",
          {
            staticClass:
              "mx-4 sm:mx-26 md:mx-40 lg:mx-52 xl:mx-76 2xl:mx-92 pb-14",
          },
          [
            _c(
              "div",
              {
                staticClass: "flex flex-col items-center justify-center w-full",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "relative w-[80%] lg:w-[60%] felx items-center justify-center fade-in-section",
                    attrs: { "data-delay": "0" },
                  },
                  [
                    _c("img", {
                      staticClass: "w-full h-auto",
                      attrs: { src: _vm.img4Src, alt: "大标题" },
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "relative w-full felx items-center justify-center mt-3 relative fade-in-section",
                    attrs: { "data-delay": "200" },
                  },
                  [
                    _c("img", {
                      staticClass: "w-full h-auto",
                      attrs: { src: _vm.img5Src, alt: "大标题" },
                    }),
                    _c("img", {
                      staticClass:
                        "w-[44px] h-[44px] rotate-7 absolute -top-[10px] -right-[10px]",
                      attrs: { src: require("@/assets/images/zh/6.png") },
                    }),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "relative mt-5 fade-in-section",
                attrs: { "data-delay": "400" },
              },
              [
                _c("img", {
                  staticClass: "w-[50%] h-auto",
                  attrs: { src: _vm.img7Src, alt: "小标题" },
                }),
                _c("img", {
                  staticClass: "w-full h-auto mt-2",
                  attrs: { src: _vm.img10Src },
                }),
                _c("img", {
                  staticClass:
                    "w-[28px] h-[28px] -rotate-8 absolute top-7 sm:top-12 md:top-13 lg:top-14 xl:top-10 2xl:top-10 left-1/2 -translate-x-1/2",
                  attrs: { src: require("@/assets/images/zh/6.png") },
                }),
                _c("img", {
                  staticClass:
                    "w-[28px] h-[28px] rotate-7 absolute bottom-0 right-0",
                  attrs: { src: require("@/assets/images/zh/6.png") },
                }),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "relative mt-5 fade-in-section",
                attrs: { "data-delay": "600" },
              },
              [
                _c("img", {
                  staticClass: "w-[50%] h-auto",
                  attrs: { src: _vm.img8Src },
                }),
                _c(
                  "div",
                  { staticClass: "grid grid-cols-3 gap-x-3 relative mt-4" },
                  [
                    _c("img", {
                      staticClass:
                        "w-[36px] h-[36px] -rotate-8 absolute -top-[6px] left-0",
                      attrs: { src: require("@/assets/images/zh/6.png") },
                    }),
                    _c("img", {
                      staticClass: "w-full h-auto",
                      attrs: { src: _vm.img11Src },
                    }),
                    _c("img", {
                      staticClass: "w-full h-auto",
                      attrs: { src: _vm.img12Src },
                    }),
                    _c("img", {
                      staticClass: "w-full h-auto",
                      attrs: { src: _vm.img13Src },
                    }),
                  ]
                ),
                _c("div", { staticClass: "grid grid-cols-3 gap-x-3 mt-2" }, [
                  _c("img", {
                    staticClass: "w-full h-auto",
                    attrs: { src: _vm.img14Src },
                  }),
                  _c("div", { staticClass: "relative" }, [
                    _c("img", {
                      staticClass: "w-full h-auto",
                      attrs: { src: _vm.img15Src },
                    }),
                    _c("img", {
                      staticClass:
                        "w-[36px] h-[36px] rotate-10 absolute -top-[0px] -right-[10px]",
                      attrs: { src: require("@/assets/images/zh/6.png") },
                    }),
                  ]),
                  _c("img", {
                    staticClass: "w-full h-auto",
                    attrs: { src: _vm.img16Src },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "grid grid-cols-3 gap-x-3 mt-2 relative" },
                  [
                    _c("div", { staticClass: "relative" }, [
                      _c("img", {
                        staticClass:
                          "w-[36px] h-[36px] -rotate-8 absolute -top-[0px] -right-[10px]",
                        attrs: { src: require("@/assets/images/zh/6.png") },
                      }),
                      _c("img", {
                        staticClass: "w-full h-auto",
                        attrs: { src: _vm.img17Src },
                      }),
                    ]),
                    _c("img", {
                      staticClass: "w-full h-auto",
                      attrs: { src: _vm.img18Src },
                    }),
                    _c("img", {
                      staticClass: "w-full h-auto",
                      attrs: { src: _vm.img19Src },
                    }),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "relative mt-5 fade-in-section mb-26 md:mb-0",
                attrs: { "data-delay": "800" },
              },
              [
                _c("img", {
                  staticClass: "w-[50%] h-auto",
                  attrs: { src: _vm.img9Src },
                }),
                _c("img", {
                  staticClass: "w-full h-auto mt-2",
                  attrs: { src: _vm.img20Src },
                }),
                _c("img", {
                  staticClass:
                    "w-[80px] lg:w-[100px] absolute -bottom-[16px] -right-[10px]",
                  attrs: { src: require("@/assets/images/zh/22.png") },
                }),
              ]
            ),
            _c(
              "div",
              {
                class: [
                  "z-[999] fixed bottom-0 left-0 right-0 md:hidden pt-[10px] flex flex-col items-center justify-center mx-auto fade-in-section cursor-pointer click-button ",
                ],
                style: {
                  opacity: _vm.isPressed ? 0.6 : "",
                  paddingBottom: _vm.showTabbar ? "70px" : "20px",
                  transition: "padding-bottom 0.3s ease-out",
                },
                on: {
                  mousedown: _vm.handleMouseDown,
                  mouseup: _vm.handleMouseUp,
                  touchstart: _vm.handleMouseDown,
                  touchend: _vm.handleMouseUp,
                },
              },
              [
                _c("img", {
                  staticClass: "w-[50%] h-auto",
                  attrs: { src: _vm.img23Src },
                }),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "hidden md:flex flex-col items-center justify-center mx-auto w-[60%] my-5 fade-in-section cursor-pointer click-button",
                style: { opacity: _vm.isPressed ? 0.6 : "" },
                on: {
                  mousedown: _vm.handleMouseDown,
                  mouseup: _vm.handleMouseUp,
                  touchstart: _vm.handleMouseDown,
                  touchend: _vm.handleMouseUp,
                },
              },
              [
                _c("img", {
                  staticClass: "w-full h-auto",
                  attrs: { src: _vm.img23Src },
                }),
              ]
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "hidden md:block md:mx-4 pb-14" }, [
        _c("img", {
          staticClass: "w-full h-auto",
          attrs: { src: _vm.img1WebSrc },
        }),
        _c("img", {
          staticClass: "w-full h-auto",
          attrs: { src: _vm.img2WebSrc },
        }),
        _c("img", {
          staticClass: "w-full h-auto",
          attrs: { src: _vm.img3WebSrc },
        }),
        _c(
          "div",
          {
            staticClass:
              "flex-col items-center justify-center mx-auto w-[30%] my-5 fade-in-section cursor-pointer click-button",
            style: { opacity: _vm.isPressed ? 0.6 : "" },
            on: {
              mousedown: _vm.handleMouseDown,
              mouseup: _vm.handleMouseUp,
              touchstart: _vm.handleMouseDown,
              touchend: _vm.handleMouseUp,
            },
          },
          [
            _c("img", {
              staticClass: "w-full h-auto",
              attrs: { src: _vm.img23Src },
            }),
          ]
        ),
      ]),
      _c(
        "CommonDialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("yoyoCoins.signInSuccess"),
            buttons: [
              {
                text: this.$t("common.confirm"),
                type: "secondary",
                action: "cancel",
              },
              {
                text: this.$t("yoyoCoins.title"),
                type: "primary",
                action: "go",
              },
            ],
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            "button-click": _vm.handleDialog,
            close: _vm.handleDialogClose,
          },
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("div", { staticClass: "mb-4" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("yoyoCoins.signInSuccessTitle")) +
                  " " +
                  _vm._s(_vm.yoyoCoins) +
                  " " +
                  _vm._s(_vm.$t("yoyoCoins.signInSuccessDesc")) +
                  " "
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "relative" }, [
      _c("img", {
        staticClass: "absolute top-0 right-0 w-300 h-100",
        attrs: { src: require("@/assets/images/zh/3.png"), alt: "定位" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }